export function DownCaret({ size = 'lg' }: { size?: 'sm' | 'lg' }) {
  const dimensions = size === 'sm' ? 24 : 36;
  const viewBoxSize = 24;

  return (
    <svg width={dimensions} height={dimensions} viewBox={`0 0 ${viewBoxSize} ${viewBoxSize}`}>
      <path fill="currentColor" fillRule="evenodd" d="M8.292 10.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0"
      />
    </svg>
  );
}
